import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { subtitle1, subtitle2 } from "./Login.style";
import { useNavigate } from "react-router-dom";
import ButtonLoading from "../components/ButtonLoading";

export default function Therms() {
  let navigate = useNavigate();

  return (
    <div
      style={{
        padding: "24px",
        textAlign: "center",
        margin: "0 auto",
        width: "60%",
      }}
    >
      <h1 style={{ margin: "16px 0" }}>Termos de Uso</h1>
      <p style={{ margin: "16px 0" }}>
        Sejam bem-vindos ao CERTIFY.ME. Ao utilizar nossos serviços, você
        concorda com os seguintes termos e condições.
      </p>
      <h2 style={{ margin: "16px 0" }}>Aceitação dos Termos</h2>
      <p style={{ margin: "16px 0" }}>
        Ao acessar e utilizar nossa aplicação, você concorda em cumprir e estar
        vinculado a estes Termos de Uso. Se você não concordar com esses termos,
        por favor, não utilize nossos serviços.
      </p>
      <h2 style={{ margin: "16px 0" }}>Coleta de Dados</h2>
      <p style={{ margin: "16px 0" }}>
        Ao criar um certificado, coletaremos seu endereço de e-mail. Esse e-mail
        será utilizado para:
        <ul style={{ listStyleType: "none", padding: "0" }}>
          <li>Enviar notificações relacionadas ao evento.</li>
          <li>
            Compartilhar conteúdo de marketing e informações relacionadas a
            futuros eventos e ofertas promocionais.
          </li>
        </ul>
      </p>
      <h2 style={{ margin: "16px 0" }}>Uso do Email</h2>
      <p style={{ margin: "16px 0" }}>
        O endereço de e-mail coletado não será vendido, trocado ou de outra
        forma transferido a terceiros, exceto quando necessário para a prestação
        dos serviços (por exemplo, para o criador do evento). Você pode optar
        por não receber mais comunicações a qualquer momento, seguindo as
        instruções contidas nos e-mails enviados.
      </p>
      <h2 style={{ margin: "16px 0" }}>Alterações nos Termos</h2>
      <p style={{ margin: "16px 0" }}>
        Reservamo-nos o direito de modificar estes Termos de Uso a qualquer
        momento. Alterações serão publicadas nesta página e, ao continuar a usar
        nossos serviços, você aceita os novos termos.
      </p>
      <h2 style={{ margin: "16px 0" }}>Contato</h2>
      <p style={{ margin: "16px 0" }}>
        Se você tiver dúvidas sobre esses Termos de Uso, entre em contato
        conosco pelo e-mail qazando@gmail.com.
      </p>

      <ButtonLoading
        label={"Voltar"}
        style={{
          marginTop: "16px",
        }}
        onClick={() => navigate(-1)}
      />
    </div>
  );
}
